// libraries/components/src/components/upcoming-trips/services/traverse.ts

/**
 * Port of Angular traverse.helper.ts
 *
 * Recursively walks an object and replaces any array of length 1
 * with its single element. Arrays with length != 1 are left as-is.
 */
export function traverse(object: unknown): unknown {
  if (object && typeof object === "object") {
    const o = object as Record<string, unknown>;
    for (const key in o) {
      if (!Object.prototype.hasOwnProperty.call(o, key)) {
        continue;
      }

      const value = o[key];

      if (Array.isArray(value) && value.length === 1) {
        o[key] = value[0];
        traverse(o);
      } else {
        traverse(value);
      }
    }
  }

  return object;
}
